import React, { Component, useEffect, useState } from 'react'
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { getTotalFillRate } from 'services/Accounts';
import { Grid, GridColumn, Dropdown, Icon, Popup } from 'semantic-ui-react';
import './FillRate.less'


const FillRate = ({ handleFillRateMapModalOpen, handleFillRateMapDataToShow, openPanel, filterDataToShowHandler, filterDataToShow, fillRateLastDaysHandler, lastDays, handleFillRateRefresh }) => {

    const lastDaysDropdownData = [
        {
            value: 0,
            text: "Today"
        },
        {
            value: 1,
            text: "Yesterday"
        },
        {
            value: 7,
            text: "Last 7 days"
        },
        // {
        //     value: 14,
        //     text: "Last 14 days"
        // },
        // {
        //     value: 30,
        //     text: "Last 30 days"
        // }
    ]

    const [fillRateData, setFillRateDataState] = useState(undefined);
    const [currentLastDaysSelection, setCurrentLastDaysSelection] = useState({});
    const [dataRefreshingState, setDataRefreshingState] = useState(false);
    const [dataRefreshDisabledState, setDataRefreshDisabledState] = useState(true);

    useEffect(() => {
        let lastDaysObj = _.first(_.filter(lastDaysDropdownData, item => item.value == lastDays));
        if (lastDaysObj) {
            setCurrentLastDaysSelection(lastDaysObj);
        } else {
            setCurrentLastDaysSelection(lastDaysDropdownData[0])
        }
    }, []);

    useEffect(() => {
        if (currentLastDaysSelection?.value || currentLastDaysSelection?.value == 0) {
            loadData();
        }
    }, [currentLastDaysSelection?.value]);

    const loadData = async () => {
        let totalFillRate = await getTotalFillRate(currentLastDaysSelection.value);
        if (totalFillRate.resStatus == 200) {
            setFillRateDataState(totalFillRate.data);
            setDataRefreshDisabledState(false);
            setDataRefreshingState(false)
        }
    }

    const refreshData = () => {
        setDataRefreshDisabledState(true);
        setDataRefreshingState(true)
        setTimeout(() => {
            loadData();
            handleFillRateRefresh()
        }, 1000);
    }

    const isSubFilterSelected = (filterName) => {
        if (filterDataToShow == filterName) {
            return true;
        } else {
            return false;
        }
    }

    const subFilterClickHandler = (filterName) => {
        openPanel();
        filterDataToShowHandler(filterName)
    }

    const onLastDaysChange = (e, data) => {
        setCurrentLastDaysSelection(_.first(_.filter(lastDaysDropdownData, item => item.value == data.value)));
        fillRateLastDaysHandler(data.value)
    }

    const handleMapIconClick = () => {
        handleFillRateMapModalOpen(true);
        handleFillRateMapDataToShow("total")
    }

    return (
        <div className={"Fill-Rate"}>
            <Grid>
                <Grid.Row className={"heading-row"}>
                    <Grid.Column width={5}>
                        <Dropdown fluid name="lastDays" key="act-sub-fil-lastdays"
                            selection
                            options={lastDaysDropdownData}
                            value={currentLastDaysSelection.value}
                            text={currentLastDaysSelection.text}
                            onChange={onLastDaysChange}
                        ></Dropdown>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <span className={"main-heading"}>{"Fill Rate"}</span>
                    </Grid.Column>
                    <Grid.Column textAlign={"right"} width={1} >
                        <Popup position={"bottom center"} content='Refresh' trigger={<Icon
                            onClick={() => { refreshData() }}
                            loading={dataRefreshingState}
                            size="large"
                            disabled={dataRefreshDisabledState}
                            circular
                            //size='small' 
                            //inverted 
                            //color='blue' 
                            name='refresh'
                        />} />

                    </Grid.Column>
                    {/* <Grid.Column textAlign={"right"} width={1} >
                        <Popup position={"bottom center"} content='Map' trigger={<Icon
                            onClick={() => { handleMapIconClick() }}
                            size="large"
                            circular
                            name='map'
                        />} />
                    </Grid.Column> */}
                    
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <CircularProgressbarWithChildren
                            value={fillRateData ? fillRateData.fill_rate : 0}
                            // text={`${fillRateData ? parseFloat(fillRateData.fill_rate).toFixed(2) : 0}%`}
                            styles={buildStyles({
                                // Rotation of path and trail, in number of turns (0-1)
                                rotation: 0.25,
                                marginTop: '0px',
                                // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                strokeLinecap: 'butt',

                                // Text size
                                textSize: '16px',

                                // How long animation takes to go from one percentage to another, in seconds
                                pathTransitionDuration: 0.5,

                                // Can specify path transition in more detail, or remove it entirely
                                // pathTransition: 'none',

                                // Colors
                                pathColor: `rgba(62, 152, 199, ${(fillRateData ? fillRateData.fill_rate : 0) / 100})`,
                                textColor: '#f88',
                                trailColor: '#d6d6d6',
                                backgroundColor: '#3e98c7',
                            })}>
                            {/* Put any JSX content in here that you'd like. It'll be vertically and horizonally centered. */}
                            {/* //<img style={{ width: 40, marginTop: -5 }} src="https://i.imgur.com/b9NyUGm.png" alt="doge" /> */}
                            <div className={"progresss-bar-text-container"}>
                                <div>
                                    <strong>{fillRateData?.fill_rate ? parseFloat(fillRateData.fill_rate).toFixed(2) : 0}%</strong>
                                </div>
                                <div>
                                    {"Total Requests : " + (fillRateData?.total_request ? fillRateData.total_request : "0")}
                                </div>
                                <div>
                                    {"Total Accepted : " + (fillRateData?.total_accepted ? fillRateData.total_accepted : "0")}
                                </div>
                            </div>
                        </CircularProgressbarWithChildren>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row className={"sub-filter-row"}>
                    <Grid.Column width={4}>
                        <span className={`sub-filter-text ${isSubFilterSelected("market") ? "selected" : ""}`} onClick={isSubFilterSelected("market") ? () => { } : () => { subFilterClickHandler("market") }}>{"Market"}</span>
                    </Grid.Column>
                    <Grid.Column width={8}>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <span className={`sub-filter-text ${isSubFilterSelected("category") ? "selected" : ""}`} onClick={isSubFilterSelected("category") ? () => { } : () => { subFilterClickHandler("category") }}>{"Category"}</span>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
}

export default FillRate